var React = require('react');

function SecureEndpoint (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M55.4 16.5087L27.7 0.00244141L0 16.5087V33.9201C0 50.9764 11.7656 63.8184 27.4856 67.6742L27.7001 67.7268L27.9145 67.6742C43.6241 63.8184 55.4 50.9766 55.4 33.9201V16.5087ZM1.8 33.9201V17.5315L27.7 2.09779L53.6 17.5315V33.9201C53.6 49.9667 42.6015 62.1254 27.6999 65.8728C12.7889 62.1255 1.8 49.967 1.8 33.9201ZM43.1422 24.4548L24.6586 43.0061L16.7462 35.0937L15.4734 36.3665L24.6609 45.554L44.4173 25.7253L43.1422 24.4548Z","fill":"black"}));
}

SecureEndpoint.defaultProps = {"width":"56","height":"68","viewBox":"0 0 56 68","fill":"none"};

module.exports = SecureEndpoint;

SecureEndpoint.default = SecureEndpoint;
